import { RecursivePartial } from "@/models/share.model";

class SharedService {
    static getIcon(icon: string, isFillIcon: boolean, subPath: string):  string {
        return isFillIcon && icon !== "gear"
            ? require(`@/assets/images/${subPath}/${icon}_fill.svg`)
            : require(`@/assets/images/${subPath}/${icon}.svg`);
    }

    
static cleanObject<T extends Record<string, any>>(input: T, deep = false): Partial<T> {
        const clone: RecursivePartial<T> = { ...input };
        const keysToDelete: (keyof T)[] = [];
      
        for (const key in clone) {
          const value = clone[key];
          if (value === null || value === undefined || value === '') {
            keysToDelete.push(key);
          } else if (deep && typeof value === 'object') {
            clone[key] = SharedService.cleanObject(value, deep);
          }
        }
      
        for (const key of keysToDelete) {
          delete clone[key];
        }
      
        return clone as Partial<T>;
      }
}

export default SharedService;